module.exports = " <div> <div v-on:click=mask class=mask v-bind:class={hide:!focus}></div> <div class=\"search false\" v-bind:class={focus:focus}> <div class=input> <input ref=search v-on:keydown.13=submit type=search required v-model=value> <span v-on:click=search class=placeholder> <i class=\"icon paco icon-search\"></i> <span class=text>搜索</span> </span> <i class=\"icon clear paco icon-wrong\"></i> </div> <span class=cancel v-on:click=mask>取消</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 128
// module chunks = 1